/* eslint-disable
    default-case,
    no-unused-vars
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
import AppDispatcher from 'lib/Dispatcher';
import * as EventConstants from 'constants/EventConstants';
import Store from 'lib/Store';
import EditorStore from 'notebook/protocols/stores/EditorStore';

class SelectionStore extends Store {
  resetState() {
    this.restoreData = null;
  }

  getState() {
    return {restoreData: this.restoreData};
  }

  payloadHandler(action) {
    switch (action.actionType) {
      case EventConstants.SELECTION_SET: {
        const {data} = action;
        this.restoreData = data;
        this.emitChange();
        break;
      }

      case EventConstants.EDITOR_REPLACE:
      case EventConstants.DOCUMENT_REVERT:
      case EventConstants.ENTRY_REVERT:
      case EventConstants.NOTE_REPLACE:
      case EventConstants.WORKFLOW_STAGE_ENTRY_REVERT:
      case EventConstants.TEMPLATE_REVERT:
      case EventConstants.SUBTEMPLATE_REVERT: {
        const {restoreData} = action;
        this.restoreData = restoreData;
        this.emitChange();
        break;
      }

      case EventConstants.EDITOR_OPEN_COMPLETED: {
        const {protocolID, protocol} = action;
        if (protocolID === this.protocolID) {
          this.restoreData =
            protocol.name.length === 0
              ? {
                  key: 'title',
                  data: {
                    selection: {
                      cid: 'titleeditor',
                      start: 0,
                      end: 0,
                    },
                  },
                }
              : null;
          this.emitChange();
        }
        break;
      }

      case EventConstants.EDITOR_CLOSE:
        this.resetState();
        this.emitChange();
        break;
    }

    return true;
  }
}

const selectionStore = new SelectionStore(AppDispatcher);
export default selectionStore;
